import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { REPORT_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class ReportService {
  static getSeoList = async data => {
    try {
      const res = await HTTPHandler.post(REPORT_API_URL + '/seo/list', data)
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
  static getListDepartments = async data => {
    try {
      const res = await HTTPHandler.post(
        REPORT_API_URL + '/seo/getListDepartments',
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
  static getListManagers = async data => {
    try {
      const res = await HTTPHandler.post(
        REPORT_API_URL + '/seo/getListManagers',
        data
      )

      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
}
